import {RequestService} from '../RequestService/RequestService';
import {insertThrobber, removeThrobber} from '../Utility/GlobalFunctions';
import {Toast} from 'toaster-js/umd.js';
import {Modal} from '../Modal/Modal';
import {DirectlyDownloadFileOnProductPage} from '../Downloads/DirectlyDownloadFileOnProductPage';

export class LoginController {
  private loginForm;
  private loginError;
  private userPopUp;
  private userProfile;
  private userEmail;
  private authenticationContainer;
  private headerUser;
  private ssoActive: boolean = false;
  private ssoHref: string = '';
  private loginFormPassword: Element[] = [];
  private loginFormButton: Element[] = [];
  private loginButtonSso: Element[] = [];
  private forgotPasswordButton;
  private forgotPasswordForm;
  private loginFormloginButton;
  private loginFormRegisterForm;
  private loginFormRegisterButton;

  constructor() {
    if (document.getElementsByClassName('tx-slnr-downloads') || document.getElementsByClassName('product-page')) {
      this.loginForm = document.querySelectorAll('.js-loginForm');
      this.loginError = document.querySelector('.js-loginError');
      this.userPopUp = document.getElementById('js-dc-user-popup');
      this.userProfile = document.querySelector('.js-UserProfile');
      this.userEmail = document.querySelector('.js-userEmail');
      this.authenticationContainer = document.querySelector('.js-login-request');
      this.headerUser = document.querySelector('.js-header-user');
      this.forgotPasswordButton = document.querySelector('.js-forgot-password-button');
      this.forgotPasswordForm = document.querySelector('.js-forgot-password-form');
      this.loginFormloginButton = document.querySelector('.js-login-form-headingLogin');
      this.loginFormRegisterForm = document.querySelector('.js-login-register');
      this.loginFormRegisterButton = document.querySelector('.js-login-form-headingRegister');
      this.init();
      this.loginFormPassword = Array.from(document.getElementsByClassName('js-LoginFormPassword'));
      this.loginFormButton = Array.from(document.getElementsByClassName('js-LoginFormButton'));
      this.loginButtonSso = Array.from(document.getElementsByClassName('js-LoginFormButtonSso'));
    }
  }

  showSso(email: string) {
    if (this.ssoActive) {
      return;
    }

    this.loginFormPassword.forEach((element) => {
      element.setAttribute('style', 'display: none;');
    });
    this.loginFormButton.forEach((element) => {
      element.setAttribute('style', 'display: none;');
    });
    this.loginButtonSso.forEach((element) => {
      element.setAttribute('style', 'display: block;');
      Array.from(element.getElementsByTagName('a')).forEach((a: HTMLAnchorElement) => {
        if (this.ssoHref === '') {
          this.ssoHref = a.href;
        }
        a.href = this.ssoHref + '?email=' + email;
      });
    });
    const pass = document.getElementById('pass');
    if (pass) {
      if (pass.hasAttribute('required')) {
        pass.removeAttribute('required');
      }
    }
    if (window.location.hash) {
      localStorage.setItem('hash', location.hash);
    }
    this.ssoActive = true;
  }

  hideSso() {
    if (!this.ssoActive) {
      return;
    }
    this.loginFormPassword.forEach((element) => {
      element.setAttribute('style', 'display: block;');
    });
    this.loginFormButton.forEach((element) => {
      element.setAttribute('style', 'display: block;');
    });
    this.loginButtonSso.forEach((element) => {
      element.setAttribute('style', 'display: none;');
    });
    const pass = document.getElementById('pass');
    if (pass) {
      pass.setAttribute('required', 'required');
    }
    this.ssoActive = false;
  }

  init() {
    this.loginForm.forEach(forms => {
      forms.addEventListener('submit', e => {
        e.preventDefault();
        const form = e.target as HTMLFormElement;
        if (this.ssoActive && this.loginButtonSso.length > 0) {
          const anchors = this.loginButtonSso[0].getElementsByTagName('a');
          if (anchors.length === 0) {
            return false;
          }
          const href = anchors[0].getAttribute('href');
          if (href) {
            location.href = href;
            return false;
          }
        }
        insertThrobber(form);
        this.login(form);
      });
      for (let input of forms.getElementsByClassName('js-loginFormUser')) {
        input.addEventListener('change', e => {
          this.toggle();
        });
        input.addEventListener('keyup', e => {
          this.toggle();
        });
      }
    });

    this.getLoginState();
    setTimeout(
      () => {
        this.toggle();
      },
      100);

    if (this.forgotPasswordButton) {
      this.forgotPasswordButton.addEventListener('click', () => {
        if (this.loginForm) {
          this.loginForm.forEach((e) => {
            e.classList.add('hidden');
          });
        }
        this.forgotPasswordForm.classList.remove('hidden');
        this.loginFormloginButton.classList.remove('loginForm__headingLogin--active');
        this.loginFormRegisterButton.classList.remove('loginForm__headingLogin--active');
      });
    }

    if (this.loginFormloginButton) {
      this.loginFormloginButton.addEventListener('click', () => {
        if (this.loginForm) {
          this.loginForm.forEach((e) => {
            e.classList.remove('hidden');
          });
        }
        this.forgotPasswordForm.classList.add('hidden');
        this.loginFormRegisterForm.classList.add('hidden');
        this.loginFormloginButton.classList.add('loginForm__headingLogin--active');
        this.loginFormRegisterButton.classList.remove('loginForm__headingRegister--active');
      });
    }

    if (this.loginFormRegisterButton) {
      this.loginFormRegisterButton.addEventListener('click', () => {
        if (this.loginForm) {
          this.loginForm.forEach((e) => {
            e.classList.add('hidden');
          });
        }
        this.loginFormRegisterForm.classList.remove('hidden');
        this.forgotPasswordForm.classList.add('hidden');
        this.loginFormRegisterButton.classList.add('loginForm__headingRegister--active');
        this.loginFormloginButton.classList.remove('loginForm__headingLogin--active');
      });
    }
  }

  private toggle() {
    const user = document.getElementById('user');
    if (!user) {
      return;
    }
    if (user.tagName.toLowerCase() === 'input') {
      const userInputElement: HTMLInputElement = <HTMLInputElement>user;
      const value: string = userInputElement.value;
      if (value.endsWith('@schleuniger.com') || value.endsWith('@schleuniger.de') || value.endsWith('@komaxgroup.com') ||
        value.endsWith('@schleuniger.co.jp') || value.endsWith('@schleuniger.ch')) {
        this.showSso(value);
      } else {
        this.hideSso();
      }
    }
  }

  private async login(form) {
    const options = {
      method: form.method,
      body: new FormData(form),
    };
    const data = await new RequestService().getRequest(form.action, options);
    const doc = new DOMParser().parseFromString(data, 'text/xml');
    const error = doc.querySelector('.js-error-message');
    removeThrobber();
    if (error) {
      const loginError = form.querySelector('.js-loginError');
      if (loginError) {
        loginError.innerHTML = '';
        loginError.insertAdjacentHTML('beforeend', data);
      }
    } else {
      const responseData = new DOMParser().parseFromString(data, 'text/xml');
      const div = responseData.querySelector('[data-toast-message]') as HTMLElement;
      if (div) {
        const message = div.getAttribute('data-toast-message');
        new Toast(message, Toast.TYPE_INFO, Toast.TIME_NORMAL);
      }
      if (form.parentElement.classList.contains('modal-content')) {
        Modal.hideModal();
      }
      this.setUserProfile(data);
      this.headerUser.classList.remove('hidden');
      const productDetailPage = document.querySelectorAll('.js-ajax');
      if (productDetailPage) {
        this.unlockDownloadInProductDetail(productDetailPage);
      }
      if (window.location.href !== this.removeURLParameter(window.location.href, 'logintype')) {
        window.location.href = this.removeURLParameter(window.location.href, 'logintype');
      } else {
        window.location.reload();
      }
    }
  }

  private removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    let urlparts = url.split('?');
    if (urlparts.length >= 2) {

      let prefix = encodeURIComponent(parameter) + '=';
      let pars = urlparts[1].split(/[&;]/g);

      //reverse iteration as may be destructive
      for (let i = pars.length; i-- > 0;) {
        //idiom for string.startsWith
        if (pars[i].lastIndexOf(prefix, 0) !== -1) {
          pars.splice(i, 1);
        }
      }

      url = urlparts[0] + '?' + pars.join('&');
      return url;
    } else {
      return url;
    }
  }

  private async getLoginState() {
    const data = await new RequestService().getRequest(this.authenticationContainer.dataset.url, {});
    const doc = new DOMParser().parseFromString(data, 'text/xml');
    const error = doc.querySelector('.js-error-message');
    if (!error) {
      this.headerUser.classList.remove('hidden');
      //check if user is on download center page
      const downloadPage = document.querySelector('.js-slnr-downloads');
      if (downloadPage) {
        this.setUserProfile(data);
      }
      const productDetailPage = document.querySelectorAll('.js-ajax');
      if (productDetailPage) {
        this.unlockDownloadInProductDetail(productDetailPage);
      }
    }
  }

  private setUserProfile(data) {
    if (this.userProfile) {
      this.userProfile.classList.remove('hidden');
    }
    const loginDiv = document.querySelector('.js-LoginPopup');
    if (loginDiv) {
      loginDiv.classList.add('hidden');
    }
    const tab = document.querySelector('li.js-dc-user-tab');
    if (tab) {
      tab.classList.add('active');
      const tabContent = document.querySelector('.js-dc-user-tab-content');
      if (tabContent) {
        tabContent.classList.remove('hidden');
      }
      this.userEmail.innerHTML = '';
      this.userEmail.insertAdjacentHTML('beforeend', data);
    }
  }

  private async unlockDownloadInProductDetail(productDetailPage) {
    const formData = new FormData();
    let mediaIds = '';
    productDetailPage.forEach(elem => {
      if (elem instanceof HTMLElement) {
        if (elem.dataset.mediaSource) {
          mediaIds = mediaIds + '|' + elem.dataset.mediaSource;
        }
      }
    });

    if (mediaIds !== '') {
      formData.append('mediaIds', mediaIds);
      const options = {
        method: 'POST',
        body: formData,
      };
      const responseData = await new RequestService().getRequest('api/getmedia/', options);
      const downloadLockSection = document.querySelector('.js-lockedFiles');
      if (downloadLockSection) {
        downloadLockSection.innerHTML = '';
        downloadLockSection.innerHTML = responseData;
        DirectlyDownloadFileOnProductPage.downloadFile();
      }
    }
  }
}
